<!--
 * @Description: 支付筛选页
 * @Date: 2020-12-11 18:32:30
-->
<template>
  <div class="to-settlement">
    <div style="text-align: center">
      <el-row :gutter="10" type="flex" justify="center">
        <el-col :span="24">
          您当前勾选订单中，有相关服务费费用需同步支付。请您确认！
        </el-col>
      </el-row>
      <el-table
        border
        header-row-class-name="tableHeader"
        :data="needPayServicesPriceList"
        style="width: 100%"
        align="center"
        header-align="center"
        height="300"
      >
        <el-table-column
          align="center"
          prop="projectName"
          label="项目名称"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="createDate"
          label="提交日期"
        ></el-table-column>
        <el-table-column align="center" label="费用类型">
          <template slot-scope="scope">
            <p>{{ scope.row.idPriceType | priceTypeFilter }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="金额">
          <template slot-scope="scope">
            <p>{{ scope.row.platformServicesPrice | moneyFixed }}</p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="text-align:right">
      <!-- 注：单个项目每月的平台服务费仅需支付一次。 -->
      <div style="margin-top:20px">
        <el-button @click="close">返回</el-button>

        <el-button type="primary" @click="confirm">确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { csoCustomerOrder } from '@/api/ajax';
import { ORDER_PRICE_TYPE } from '@/common/constants/order';
export default {
  name: 'ToPayFee',
  cname: '提示',
  props: {
    // 上个页面的已选数据
    preSelection: {
      type: Array,
      default() {
        return [];
      }
    },
    needPayServicesPriceList: {
      type: Array,
      default() {
        return [];
      },
      required: true
    }
  },
  data() {
    return {
      balance: '-', // 账户余额
      dataCount: '', // 订单数
      sumAmount: '', // 总金额
      config: null,
      selection: [],
      tableData: [],
      balanceLoading: true
    };
  },
  methods: {
    // 获取当前所选订单钱、数
    async getCurrentSelectionInfo() {
      let { data } = await csoCustomerOrder.needPayServicesPriceInfo({
        csoCustomOrderIds: this.csoCustomOrderIds
      });
      this.tableData = data.data.needPayServicesPriceList;
    },
    async confirm() {
      this.$emit('confirm', this.needPayServicesPriceList);
    },
    close() {
      this.$emit('cancel', this.needPayServicesPriceList);
      this.$xrkDialog.remove();
    }
  },
  filters: {
    priceTypeFilter(v) {
      const type = v.split('_')[1];
      return ORDER_PRICE_TYPE[type].label;
    }
  }
};
</script>

<style scoped lang="scss">
.to-settlement {
  width: 70vw;
}
.tableHeader th {
  // color: red !important;
  font-weight: 800;
  background-color: #fbfbfb !important;
}
</style>
